import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import React, { useEffect, useState } from 'react';
import { useFutureOrderStore } from '../../../../components/Stores/FutureOrdersStore';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { toast } from 'react-toastify';
import { isFormFilledCorrectly } from './FillOrderDetailsUtils';

interface Props {
  nextAction: () => void;
  backAction: () => void;
  isNextLoading?: boolean;
  isEditMode?: boolean;
  setIsInEditMode?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FOModifyProductDeliveriesButtonSection: React.FC<Props> = ({
  backAction,
  nextAction,
  isEditMode = true,
  isNextLoading = false,
  setIsInEditMode,
}) => {
  const [formState, setFormState] = useState<{ state: boolean; massage: string }>({ massage: '', state: true });
  const { editedFutureOrder } = useFutureOrderStore();

  useEffect(() => {
    setFormState(isFormFilledCorrectly(editedFutureOrder));
  }, [editedFutureOrder]);

  return (
    <div className="space-x-4 flex sticky bottom-0 bg-white pt-2 ">
      <ButtonDesigned style="outline" className="pt-2" onButtonClick={backAction}>
        <div className="flex ">
          <img className=" my-auto rotate-180" title="Right" src="/assets/icons/flat/chevron-right_purple.svg"></img>
          Back
        </div>
      </ButtonDesigned>
      {isEditMode && setIsInEditMode ? (
        <ButtonDesigned
          style="primary"
          className="px-4"
          onButtonClick={() => (formState.state ? setIsInEditMode(false) : toast.error(formState.massage))}
        >
          save
        </ButtonDesigned>
      ) : (
        <ButtonDesigned
          disableButton={!formState.state || isNextLoading}
          style="primary"
          className="py-2 flex items-center"
          isFunctionLoading={isNextLoading}
          onButtonClick={nextAction}
        >
          <div className="flex items-center">
            Next
            <img className=" invert  h-5" title="Right" src="/assets/icons/flat/chevron_right.svg"></img>
          </div>
        </ButtonDesigned>
      )}
      {!isEditMode && setIsInEditMode && (
        <div className="flex ms-auto ">
          <ButtonDesigned
            onButtonClick={() => {
              setIsInEditMode(true);
            }}
            style="outline"
          >
            <div className="space-x-4 flex">
              <BorderColorOutlinedIcon />
              <p className="my-auto">Edit</p>
            </div>
          </ButtonDesigned>
        </div>
      )}
    </div>
  );
};
